import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Layout } from '@/components/layout/Layout';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ArrowRight, Newspaper, Calendar } from 'lucide-react';

const news = [
  {
    title: 'Square Trigger Named Top Digital Agency in Canada',
    date: 'January 2024',
    excerpt: 'We\'re proud to announce that Square Trigger has been recognized as one of the top digital agencies in Canada.',
    category: 'Award'
  },
  {
    title: 'Expanding Our Service Offerings',
    date: 'December 2023',
    excerpt: 'We\'re excited to announce new service offerings to better serve our clients\' growing digital needs.',
    category: 'Company News'
  },
  {
    title: 'Partnership with Leading Tech Company',
    date: 'November 2023',
    excerpt: 'Square Trigger partners with a leading technology company to bring cutting-edge solutions to our clients.',
    category: 'Partnership'
  },
  {
    title: 'New Office Opening',
    date: 'October 2023',
    excerpt: 'We\'re opening a new office to accommodate our growing team and better serve our clients.',
    category: 'Company News'
  }
];

export default function NewsPage() {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-muted/50 to-background">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto"
          >
            <Badge variant="secondary" className="mb-6">
              <Newspaper className="h-4 w-4 mr-2" />
              News & Press
            </Badge>
            <h1 className="text-4xl sm:text-5xl font-display font-bold text-foreground mb-6">
              News &{' '}
              <span className="gradient-text">Press</span>
            </h1>
            <p className="text-lg text-muted-foreground">
              Stay updated with the latest news and announcements from Square Trigger.
            </p>
          </motion.div>
        </div>
      </section>

      {/* News Grid */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {news.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <Card className="p-6 h-full border-border hover:border-primary/30 transition-all duration-300 card-hover">
                  <Badge variant="secondary" className="mb-4">
                    {item.category}
                  </Badge>
                  <h3 className="text-xl font-display font-semibold text-foreground mb-2">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground mb-4">
                    {item.excerpt}
                  </p>
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <Calendar className="h-4 w-4" />
                    {item.date}
                  </div>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 gradient-primary">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h2 className="text-3xl md:text-4xl font-display font-bold text-primary-foreground mb-6">
              Media Inquiries?
            </h2>
            <p className="text-primary-foreground/80 mb-8">
              Contact our press team for interviews and media requests.
            </p>
            <Button variant="premium" size="lg" asChild className="bg-background text-foreground hover:bg-background/90">
              <Link to="/contact">
                Contact Press Team
                <ArrowRight className="h-5 w-5 ml-2" />
              </Link>
            </Button>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
}
